import type { GestureType, MapInitializationOptions } from '../maps';
import { MapControl } from '../maps';

import { TRIPPLANNER_MAP_ID } from './constants';

const GOOGLE_MAP_ID_BASE = 'google-map';
let numberOfinstances = 0;

export function getSingleMapContainer(): HTMLElement | null {
  for (let mapId = 0; mapId < numberOfinstances; mapId++) {
    const googleMapElement = document.getElementById(
      `${GOOGLE_MAP_ID_BASE}-${mapId}`
    );
    if (googleMapElement && googleMapElement.parentNode === document.body) {
      return googleMapElement;
    }
  }
  return null;
}

export function setSingleMapContainer(): HTMLElement {
  const mapContainer = document.createElement('div');
  mapContainer.classList.add(GOOGLE_MAP_ID_BASE);
  mapContainer.id = `${GOOGLE_MAP_ID_BASE}-${numberOfinstances}`;
  return mapContainer;
}

export function setGoogleMapInstance(
  googleMapElement: HTMLElement,
  options?: MapInitializationOptions
): google.maps.Map {
  const googleMapOptions = options ? getGoogleMapOptions(options) : undefined;
  if (googleMapOptions) {
    googleMapOptions['mapId'] = TRIPPLANNER_MAP_ID;
  }

  numberOfinstances++;
  return new google.maps.Map(googleMapElement, googleMapOptions);
}

export function updateMapInstanceOptions(
  googleMapInstance: google.maps.Map,
  options?: MapInitializationOptions
): void {
  if (!options) {
    return;
  }
  const googleMapOptions = getGoogleMapOptions(options);
  googleMapInstance.setOptions(googleMapOptions);
}

export function putMapInContainer(
  container: HTMLElement,
  mapElement: HTMLElement
): void {
  mapElement.style.display = 'block';
  container.appendChild(mapElement);
}

export function putMapInBody(googleMapElement: HTMLElement): void {
  googleMapElement.style.display = 'none';
  document.body.appendChild(googleMapElement);
}

function getGoogleMapOptions(
  options: MapInitializationOptions
): google.maps.MapOptions {
  return {
    clickableIcons: false,
    gestureHandling: options?.gestureHandling ?? ('auto' as GestureType),
    zoomControl: options?.mapControls.includes(MapControl.zoomControl),
    mapTypeControl: options?.mapControls.includes(MapControl.mapTypeControl),
    scaleControl: options?.mapControls.includes(MapControl.scaleControl),
    streetViewControl: options?.mapControls.includes(
      MapControl.streetViewControl
    ),
    rotateControl: options?.mapControls.includes(MapControl.rotateControl),
    fullscreenControl: options?.mapControls.includes(
      MapControl.fullscreenControl
    ),
  };
}
